// @ts-nocheck

import React from "react";
import mammoth from "mammoth/mammoth.browser.min.js";

import { Document } from "@planzone/dto";
import { Props } from "./types";
import styles from "./styles.scss";

function loadDoc({ uri }: Document) {
  return fetch(uri)
    .then((res) => res.arrayBuffer())
    .then((doc) =>
      mammoth.convertToHtml({ arrayBuffer: doc }).then(({ value }) => value),
    );
}

function useDoc(document: Document) {
  const [data, setData] = React.useState({
    isPending: false,
    html: "",
  });

  React.useEffect(() => {
    if (!data.isPending) {
      setData((s) => ({ ...s, isPending: true }));
      loadDoc(document).then((html) => setData({ isPending: false, html }));
    }
  }, [document.uri]);

  return data;
}

function DocxRenderer({ document, file }: Props) {
  const { isPending, html } = useDoc({ ...document, uri: file.uri });

  return (
    <div className={styles.renderer}>
      <div
        className={styles.content}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
}

export { DocxRenderer };
